import { Navigate, useOutlet } from "react-router-dom";

export const ProtectedLayout = () => {
  const user = JSON.parse(localStorage.getItem("user-data"));
  console.log(user,"Sdjksadjkdasjdjasdasjk")
  const outlet = useOutlet();

  if (!user) {
    return <Navigate to="/" />;
  }

  return <div>{outlet}</div>;
};
